import store from './store';

const debug = false;

const storeListener = new class {

  constructor () {
    if (debug) console.log('storeListener.constructor()')
    this.authUserChangedCallbacks = []
    this.authUserReadyCallbacks = []
    this.authUserReady = false
    this.storeState = null

    store.subscribe((mutation, state) => {
      if (debug) console.log('storeListener.subscribe. mutation:',mutation,'state:',state);
      this.storeState = state
      // console.log('storeListener.subscribe. state.auth:', state.auth, 'state.auth.user:', state.auth.user);
      switch (mutation.type) {
        case 'auth/setUser':
          // if (state.auth && state.auth.user) {
          //   console.log('storeListener.subscribe. ********** LOGIN ************');
          // } else {
          //   console.log('storeListener.subscribe. ********** LOGOUT ************');
          // }
          setTimeout(() => {
            this.executeUserChange(mutation.payload);
          }, 200);
          break;
      }
    })
  }

  executeUserChange(payload) {
    if (!this.authUserReady) {
      this.authUserReady = true
      this.authUserReadyCallbacks.forEach((callback) => {
        callback(payload)
      })
      this.authUserReadyCallbacks = [];
    }
    this.authUserChangedCallbacks.forEach((callback) => {
      if (debug) console.log('storeListener.subscribe. call callback for onAuthUserChanged. callback:',callback);
      callback(payload);
    });
  }

  /**
   * Execute callback every time the user is changed
   * @param {*} callback 
   */
  onAuthUserChanged(callback) {
    this.authUserChangedCallbacks.push(callback)
  }

  /**
   * Execute callback one time when the user is set the first time
   * @param {*} callback 
   */
  onAuthUserReady(callback) {
    if (this.authUserReady) {
      callback(this.storeState.auth.user)
    }
    else {
      this.authUserReadyCallbacks.push(callback)
    }
  }
}

export default storeListener